import React from "react";

export default function Collapse({
  size = 20,
  color = "#000000",
  strokeWidth = 2,
  className,
  title,
  ...props
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden={title ? undefined : "true"}
      role="img"
      {...props}
    >
      {title ? <title>{title}</title> : null}

      <g>
        <line x1="12.73" y1="7.27" x2="19" y2="1" />
        <polyline points="17.45 7.27 12.73 7.27 12.73 2.55" />
      </g>
      <g>
        <line x1="7.27" y1="7.27" x2="1" y2="1" />
        <polyline points="7.27 2.55 7.27 7.27 2.55 7.27" />
      </g>
      <g>
        <line x1="7.27" y1="12.73" x2="1" y2="19" />
        <polyline points="2.55 12.73 7.27 12.73 7.27 17.45" />
      </g>
      <g>
        <line x1="12.73" y1="12.73" x2="19" y2="19" />
        <polyline points="12.73 17.45 12.73 12.73 17.45 12.73" />
      </g>
    </svg>
  );
}
